import React from "react";
import { Link } from "react-router-dom";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import logo from "../../images/croqee-outline-white.png";

const LOGO_WIDTH = "78px";
const LOGO_HEIGHT = "82px";

const Logo = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Link to="/" style={{ position: "absolute" }}>
      <Box
        sx={{
          width: isMobile ? `calc(${LOGO_WIDTH} * 0.80)` : LOGO_WIDTH,
          height: isMobile ? `calc(${LOGO_HEIGHT} * 0.80)` : LOGO_HEIGHT,
          backgroundColor: "rgba(19, 18, 18, 0.2)",
          position: "absolute",
          left: isMobile ? `calc(19px - (${LOGO_WIDTH} * 0.125))` : "19px",
          zIndex: "tooltip",
          userSelect: "none",
        }}
      >
        <img
          src={logo}
          id="logo"
          alt="Croqee logo"
          style={{
            width: "71%",
            height: "auto",
            position: "absolute",
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            margin: "auto",
            zIndex: 101,
          }}
          className="nav-header-title"
        />
      </Box>
    </Link>
  );
};

export default Logo;
